import News from "./News"
import History from "./History";
import Employee from "./Employee";
import OpeningHours from "./OpeningHours";
import Uebergaben from "./Uebergaben";



export class Main{

    News: News;
    History: History;
    Employee: Employee;
    OpeningHours: OpeningHours;
    Uebergaben: Uebergaben;

    constructor() {
        this.History = new History();
        this.Employee = new Employee();
        this.News = new News();
        this.OpeningHours = new OpeningHours();
        this.Uebergaben = new Uebergaben();

    }

}